import type { ChipTone } from "@/components/badge/chip";
import type { PrProgress, PrState } from "@/types/domain";

// Pull request state labels + chip tones (GitHub's own palette: open green,
// merged purple, closed red, draft grey).
export const PR_STATE: Record<PrState, { label: string; tone: ChipTone; textClassName: string }> = {
  draft: { label: "Draft", tone: "neutral", textClassName: "text-muted-foreground" },
  open: { label: "Open", tone: "green", textClassName: "text-chip-green-foreground" },
  merged: { label: "Merged", tone: "purple", textClassName: "text-chip-purple-foreground" },
  closed: { label: "Closed", tone: "red", textClassName: "text-chip-red-foreground" },
};

// Compact `#N` badges on lists only care whether the PR has landed:
// merged → primary, anything else (draft/open/closed) → destructive.
export const prBadgeTone = (state: PrState): { tone: ChipTone; textClassName: string } =>
  state === "merged"
    ? { tone: "primary", textClassName: "text-primary" }
    : { tone: "destructive", textClassName: "text-destructive" };

// Rendering only: the server owns the PR aggregation rules (WED-153).
export const PR_PROGRESS: Record<PrProgress, { label: string; tone: ChipTone }> = {
  none: { label: "未关联 PR", tone: "neutral" },
  in_review: { label: "评审中", tone: "blue" },
  merged: { label: "已完成", tone: "purple" },
  abandoned: { label: "已放弃", tone: "neutral" },
};
